import { useState } from "react";
import {
  Box,
  Button as UIButton,
  FormControlLabel,
  Checkbox,
  Collapse,
} from "@mui/material";
import ArrowDownSLineIcon from "remixicon-react/ArrowDownSLineIcon";
import ArrowUpSLineIcon from "remixicon-react/ArrowUpSLineIcon";
import Edit2LineIcon from "remixicon-react/Edit2LineIcon";
import SyncAltOutlined from "@mui/icons-material/SyncAltOutlined";
import { Text, InfoContainer } from "$components";
import { entrepotActivities } from "$utils/typeConstants/Entrepot";
import { Warehouse } from "$types";
import useStyles from "./useStyles";

type Props = {
  entrepot: Warehouse;
  onEditClick: () => void;
};

function Activities({ entrepot, onEditClick }: Props) {
  const classes = useStyles();
  const [displayActivityDetails, setDisplayActivityDetails] =
    useState<boolean>(false);
  const { activities } = entrepot || {};
  const mainActivities = entrepotActivities.filter((a) => a.isAMainActivity);

  return (
    <InfoContainer
      className={classes.activitiesBlock}
      leftHeader={
        <div className={classes.infoHeader}>
          <SyncAltOutlined />
          <Text type="h3">Activité(s)</Text>
        </div>
      }
      rightHeader={
        <UIButton className={classes.editButton} onClick={onEditClick}>
          <Edit2LineIcon />
        </UIButton>
      }
    >
      <div className={classes.activitiesContainer}>
        <Box display="flex" alignItems="center" width="100%">
          {mainActivities.map((a) => (
            <FormControlLabel
              key={`activity-${a.title}`}
              control={
                <Checkbox
                  checked={(activities || []).includes(a.value)}
                  name="mainActivities"
                  color="primary"
                  style={{ cursor: "default" }}
                />
              }
              label={a.title}
              style={{ cursor: "default" }}
            />
          ))}
        </Box>

        <Box
          width="100%"
          display="flex"
          alignItems="center"
          onClick={() => setDisplayActivityDetails(!displayActivityDetails)}
          style={{ color: "#2D2D2D" }}
          className={classes.activitiesDetails}
        >
          <Text style={{ fontSize: 18 }}>Détail des activités </Text>
          {displayActivityDetails ? (
            <ArrowUpSLineIcon />
          ) : (
            <ArrowDownSLineIcon />
          )}
        </Box>
        <Collapse in={displayActivityDetails}>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {(entrepotActivities || [])
              .filter(({ parent }: any) => parent === "")
              .map((a: any) => (
                <div key={a.value} className={classes.activitiesGroup}>
                  <FormControlLabel
                    className={classes.activities}
                    control={
                      <Checkbox
                        checked={(activities || []).includes(a.value)}
                        name="acts"
                        color="primary"
                        style={{ cursor: "default" }}
                      />
                    }
                    label={a.title}
                    style={{ cursor: "default" }}
                  />
                  <div className={classes.subActivitiesBloc}>
                    {entrepotActivities
                      .filter(({ parent }: any) => parent === a.value)
                      .map((b: any) => (
                        <FormControlLabel
                          key={b.value}
                          checked={(entrepot?.activities || []).includes(
                            b.value
                          )}
                          className={classes.subActivities}
                          control={
                            <Checkbox
                              name="acts"
                              color="primary"
                              style={{ cursor: "default" }}
                            />
                          }
                          label={b.title}
                          style={{ cursor: "default" }}
                        />
                      ))}
                  </div>
                </div>
              ))}
          </div>
        </Collapse>
      </div>
    </InfoContainer>
  );
}

export default Activities;
